let tmpAForConversion = null;

export default function convertUrl(url) {
  if (!tmpAForConversion) {
    tmpAForConversion = document.createElement('a');
  }
  tmpAForConversion.href = url;
  return tmpAForConversion.href;
}
